import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ParametrizarParametrosModel } from './ParametrizarParametros.model';
import { OpcionModel } from '../Global/Opcion.model';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';


@Component({
	selector: 'ParametrizarParametros',
	templateUrl: './ParametrizarParametrosEdit.component.html'
})

/**
* @author Camilo
* @since  26/10/2017
**/
export class ParametrizarParametrosEdit {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public form: FormGroup;
	public formErrors: any;
	public parametro: ParametrizarParametrosModel;
	public parametros: Array<ParametrizarParametrosModel> = new Array();
	public guardando: boolean;
	public nanno: number;
	public bloquearLLave: boolean = false;
	public labelCampo: string = "";
	public bloquearValor: boolean = true;
	public tipoEmpresa: string = "";

	public ocultar: boolean= false;
	public mensaje: string="";


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
		this.formErrors = {

			nunidadesuvt: {},
			nvaloruvt: {},
			nanno: {}
		};

		this.parametros = new Array();

		this.parametro = new ParametrizarParametrosModel(0, 0, 0);
		this.guardando = false;

		var x = this._serviciosGenerales.seguridad.getInfoToken();
		this.tipoEmpresa = JSON.parse(x.ntipoempresa).ntipoempresa + ' - ' + JSON.parse(x.tipoempresa).tipoempresa;

		//console.log("----> ",this.tipoEmpresa);

	}

	ngOnInit() {
		this._route.params.subscribe(params => {
			console.log('------------------------->', params['nanno'].split(' ').join(''), ' -- ', params, ' ------------ ', (!!params['nanno']));


			if (!!params['nanno'] == true) {
				this.nanno = params['nanno'];
				this.bloquearLLave = true;
			} else {
				this.nanno = 0;
			}

			// ~~~~~~ Se carga la info básica ~~~~~~~ //

			//this.cargarInfo();



			if (!!params['nanno']) {
				this.cargarParametrizacionUVT();
			} else {
				console.log('Antes : ', this.parametro);
				//this._serviciosGenerales.getParametros('NEGOCIOS', this.negocio);
				console.log('Despues : ', this.parametro);

			}

			this.inicializarForm();

			this.form.valueChanges.subscribe(() => {
				this.onFormValuesChanged();
			});
		});
	}

	private inicializarForm() {
		console.log('->> ', this.bloquearLLave);
		this.form = this.formBuilder.group({
			nunidadesuvt: [0, Validators.required],
			nvaloruvt: [0, Validators.required],
			nanno: [{
				value: (this.bloquearLLave == true ? this.parametro.nanno : ''),
				disabled: this.bloquearLLave
			}, Validators.required
			]
		});
	}





	private cargarParametrizacionUVT() {
		//console.log('Contrato que envía : ',this.contrato);
		this._serviciosGenerales.get('detalleParametrizacionUVT', { nanno: this.nanno }).subscribe(
			result => {
				let x = result[0];
				this.parametro = new ParametrizarParametrosModel(x.nunidadesuvt, x.nvaloruvt, x.nanno);
				console.log("=============> " + this.parametro.nunidadesuvt + "--" + this.parametro.nvaloruvt + "--" + this.parametro.nanno);
				//this.validarCampo(false);
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBar("Ocurrió un error al momento de cargar los negocios", "X");
			});

	}

	guardar() {

		console.log(this.parametro.nunidadesuvt+"-"+this.parametro.nvaloruvt+"-"+this.parametro.nanno);

		if (this.form.valid == false) {
			this.openSnackBarEspecial('Hay Campos requeridos sin llenar', 'X');
			return;
		}

		if (this.parametro.nunidadesuvt <= 0) {
			this.openSnackBarEspecial('El valor del campo Unidades UVT debe ser mayor a cero', 'X');
			return;
		}

		if (this.parametro.nvaloruvt <= 0) {
			this.openSnackBarEspecial('El valor del campo Valor UVT debe ser mayor a cero', 'X');
			return;
		}


		this._serviciosGenerales.get('validarParametrizacionUVT', {nanno:this.parametro.nanno}).subscribe(

			result =>{
				if(result[0].c > 0 && this.bloquearLLave == false){
					this.openSnackBarEspecial('Ya existe uan configuración de UVT para el año: '+this.parametro.nanno, 'X');
					
				}else{
					this.guardarSinValidacion();
				}
				
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la configuración de UVT. ", "X");
				
			});
	}

	guardarSinValidacion() {
		this.guardando = true;
		console.log(this.parametro);
		this._serviciosGenerales.post('parametrizacionUVT', this.parametro).subscribe(
			result => {
				this.openSnackBar("Proceso realizado con éxito", "X");
				this.guardando = false;
				this._router.navigate(['/ParametrizarParametros']);
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de guardar la configuración UVT", "X");
			}
		);
	}


	onFormValuesChanged() {
		for (const field in this.formErrors) {

			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}


	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}
	openSnackBarEspecial(message: string, action: string) {
        let snackBarRef =  this.snackBar.open(message, action);
 
        snackBarRef.onAction().subscribe(() => {
           
            this.ocultar = false;
            this.mensaje = "";
        });
        
        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
        
        if (shand.length != 0) {
                for (let i=0;i<shand.length;i++){
                shand[i].style.backgroundColor = "rgb(255 204 214)";
                }
            }
    }
}





// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ParametrizarParametros/ParametrizarParametrosEdit.component.ts